import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { ERROR, priceDynamicFilters } from 'src/app/shared/shared-config';
import { DASHBOARD } from 'src/app/shared/static';
import { CONFIG } from 'src/helper/app-config';
import { cloneDeep, errorOrSuccessPopup } from 'src/helper/utilities';
// import { DATA_VARIABLE_INITIAL } from 'src/shared/common';
import { RESET_PE, STATIC_DATA, TIME_PERIOD } from 'src/shared/data-store';
import Swal from 'sweetalert2';
import { utils, writeFileXLSX } from 'xlsx';

@Component({
  selector: 'app-pe-decom',
  templateUrl: './pe-decom.component.html',
  styleUrl: './pe-decom.component.scss',
})
export class PeDecomComponent implements OnInit {
  keepOriginalOrder = (): number => {
    return 0;
  };

  peValues = {};
  maxRange = 33.33;
  isReset = false;

  displayedColumns: string[] = [
    'retailer',
    'Category',
    'BrandPackVariant',
    'gross_elasticity',
    // 'revised_pe',
    'gross_internal',
    'manufacturer_walk_rate',
  ];

  isRevisedColChange = false;

  onSave(): void {
    const manufacturerWalkRate = this.dataSource.data.map((ele) => ({
      ...ele,
      walkrate: ele['walkrate'] / 100,
    }));
    const ws = utils.json_to_sheet(manufacturerWalkRate);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, '');
    writeFileXLSX(wb, `${'pe-decomp'}.xlsx`);
  }

  math = Math;
  apiCallIndex = 0;
  filterLoader = false;

  constructor(
    private dataService: DataService,
    private router: Router,
  ) {}

  dataSource = new MatTableDataSource([]);
  priceDynamicFilterData = priceDynamicFilters;
  scenarioSelectedFilters: any = {};
  scenarioFilterOptions = {};
  // scenarioFilters = cloneDeep(STATIC_DATA.OUTPUT_SCENARIO_FILTERS);
  scenarioDefaultFilterOption = {};
  addLeftToRightDisableFunctionality = false;
  resetOtherFiltersBasedCurrentSelection = false;
  userChangedFilters: any = {
    retailer: ['Acronym'],
  };
  newGroupFilters = {};
  defaultFilterOption = {};
  selectedFilters: any = {};
  outputFilters = cloneDeep(STATIC_DATA.PE_FILTERS);
  selectedTimePeriod = 'Yearly';
  timePeriodOptionsOptions = TIME_PERIOD;
  activeFilters = [];
  footerShown = ['chain'];
  viewByReverseMapper = {
    Manufacturer: 'Manufacturer',
    BrandHouse: 'Brand',
    BrandVariant: 'Sub Brand',
    BrandPackVariant: 'SKU',
    size: 'Size',
    Category: 'Category',
    marca: 'Brand',
    tier: 'Tier',
    tipo: 'Tipo',
    description_material: 'SKU',
    chain_final: 'Chain',
    cod_softys: 'Code softys',
  };

  viewByMapper = {
    Size: 'size',
    Category: 'Category',
    Brand: 'marca',
    Tier: 'tier',
    Tipo: 'tipo',
    SKU: 'description_material',
    Chain: 'chain_final',
    'Code softys': 'cod_softys',
    Region: 'chain_final',
  };
  tableDataLoader = false;
  selectedRetailer = 'Acronym';
  selectedCategory = 'Pencils';
  channelOption = [];
  categoryOptions = [];

  selectionChangeChannel(value) {
    this.selectedCategory = 'Pencils';
    this.userChangedFilters = {
      retailer: [value],
    };
    this.updateFilters().then((res) => {
      this.categoryOptions = this.newGroupFilters['Category'];
    });
    this.activeFilters = [];
  }

  selectionCategory(value) {
    this.userChangedFilters = {
      retailer: [this.selectedRetailer],
      Category: [value],
    };

    this.updateFilters().then((res) => {
      this.getTableData();
    });
    this.activeFilters = [];
  }

  scenarioFilterHandle(eventObj) {
    this.scenarioSelectedFilters = eventObj['overAllSelections'];
    if (eventObj.event === 'apply' || eventObj.event === 'clear') {
    }
  }

  mergeObjects(obj1, obj2) {
    const result = {};

    // Function to merge arrays and keep only unique values
    const mergeArrays = (arr1, arr2) => [...new Set([...arr1, ...arr2])];

    // Iterate over keys in obj1
    for (const key in obj1) {
      if (obj1.hasOwnProperty(key)) {
        // Check if the key is present in obj2
        if (obj2.hasOwnProperty(key)) {
          // Merge arrays and store unique values in the result object
          result[key] = mergeArrays(obj1[key], obj2[key]).filter((ele) => ele);
        } else {
          // If the key is not present in obj2, copy the array from obj1

          result[key] = [...obj1[key]].filter((ele) => ele);
        }
      }
    }

    // Iterate over keys in obj2 that are not present in obj1
    for (const key in obj2) {
      if (obj2.hasOwnProperty(key) && !obj1.hasOwnProperty(key)) {
        // Copy the array from obj2 to the result object
        if (obj2[key]) {
          result[key] = [...obj2[key]].filter((ele) => ele);
        }
      }
    }

    return result;
  }

  ngOnInit(): void {
    // this.outputFilters[0]['displayName'] = 'Size';
    // this.outputFilters[0]['name'] = 'size';
    // this.outputFilters[0]['configKey'] = 'size';

    this.outputFilters = this.outputFilters.slice(1);

    this.updateFilters().then((res) => {
      this.channelOption = this.newGroupFilters['retailer'];
      this.categoryOptions = this.newGroupFilters['Category'];

      this.userChangedFilters = {
        ...this.userChangedFilters,
        Category: [this.selectedCategory],
      };

      this.updateFilters();

      this.getTableData();
    });

    this.isReset = false;
    this.isRevisedColChange = false;
  }

  updateFilters() {
    let payload = {
      base_scenario_name: '',
      filter_details: {
        available_keys: [
          'retailer',
          // 'LengthBand',
          'Manufacturer',
          // 'PackContents',
          'BrandPackVariant',
          // 'PriceSector',
          // 'TarLevel',
          'BrandVariant',
          'Category',
          'BrandHouse',
        ],
        ...this.userChangedFilters,
      },
      source: 'pe_decomp',
    };

    this.dataService.showLoader.next(true);

    this.filterLoader = true;
    return this.dataService
      .postRequest(payload, CONFIG.API2.OUTPUT_SUMMARY_DROPDOWN)
      .then((res) => {
        this.dataService.showLoader.next(false);
        let temp = {};
        const disabledKeys = res?.['disabled_keys']?.[0];
        this.activeFilters = [];

        if (disabledKeys) {
          temp = { ...disabledKeys };
          Object.keys(disabledKeys).forEach((ele) => {
            if (
              disabledKeys[ele]?.length !== 0 &&
              ele !== 'Category' &&
              ele !== 'retailer'
            ) {
              this.activeFilters.push(ele);
              console.log('active Filters', this.activeFilters);
            }
          });
        } else {
          temp = {};
        }
        this.newGroupFilters = this.mergeObjects(
          { ...res['available_keys'] },
          temp,
        );
        console.log('newGroupFilters', this.newGroupFilters);
        this.defaultFilterOption = { ...res['available_keys'] };
        this.selectedFilters = { ...this.defaultFilterOption };

        // if (this.selectedRetailer === 'TT') {
        //   this.outputFilters[0]['displayName'] = 'Region';
        //   this.viewByReverseMapper = {
        //     ...this.viewByReverseMapper,
        //     chain_final: 'Region',
        //   };
        // } else {
        //   this.outputFilters[0]['displayName'] = 'Chain';
        //   this.viewByReverseMapper = {
        //     ...this.viewByReverseMapper,
        //     chain_final: 'Chain',
        //   };
        // }
      })
      .finally(() => {
        this.filterLoader = false;
      })
      .catch((err) => {
        this.dataService.showLoader.next(false);
        errorOrSuccessPopup(ERROR, '', 'error');
      });
  }

  getThePEValueForSKU(peValue, sku, chain) {
    let keyToBe = `${chain}_${sku}`;
    this.peValues = {
      ...this.peValues,
      [keyToBe]: +peValue,
    };
    this.isRevisedColChange = true;
    this.isReset = true;
  }

  getTableData() {
    this.tableDataLoader = true;

    const data_filters = {
      ...this.selectedFilters,
      retailer: [this.selectedRetailer],
      Category: [this.selectedCategory],
    };

    const payloadForDecompData = {
      data_filters,
    };

    this.dataService
      .postRequest(payloadForDecompData, CONFIG.API2.GET_PE_DECOMP_DATA)
      .then((res: any) => {
        this.dataService.showLoader.next(false);
        res['data'].forEach((item) => {
          item['walkrate'] = item['walkrate'] * 100;
        });
        this.dataSource.data = res['data'];

        console.log('data', this.dataSource);
        this.tableDataLoader = false;
        // this.isReset = !this.dataSource.data.every(
        //   (ele) => ele['Gross Elasticity'] == ele['Revised PE'],
        // );
      })
      .catch((err) => {
        this.tableDataLoader = false;
        console.log(err);
        errorOrSuccessPopup(ERROR, '', 'error');
      });
  }

  updateRevisedPE(isReset) {
    const payload = {
      'revised-pe-data': this.peValues,
      retailer: this.selectedRetailer,
    };

    this.dataService.showLoader.next(true);

    this.dataService
      .postRequest(payload, CONFIG.API2.UPDATE_REVISED_PE)
      .then((res: any) => {
        if (res.msg == 'Revised PE Updated Successfully') {
          Swal.fire({
            icon: 'success',
            html: isReset ? RESET_PE : res.msg,
            showConfirmButton: false,
            timer: 1500,
          });
        }
        this.getTableData();
        this.peValues = {};
        this.isRevisedColChange = false;
        this.dataService.showLoader.next(false);
      })
      .catch((err) => {
        this.dataService.showLoader.next(false);
        console.log(err);
        errorOrSuccessPopup(ERROR, '', 'error');
      });
  }

  filterHandle(eventObj) {
    this.selectedFilters = eventObj['overAllSelections'];
    if (eventObj.event === 'apply' || eventObj.event === 'clear') {
      this.userChangedFilters = {
        ...this.userChangedFilters,
        [eventObj['name']]: eventObj['selectedFilters'],
      };
      this.isReset = true;

      this.updateFilters().then((res) => {
        this.selectedCategory = this.categoryOptions.includes(
          this.selectedCategory,
        )
          ? this.selectedCategory
          : this.categoryOptions[0];
        this.getTableData();
      });
    }
  }

  remove(activeFilter: string): void {
    if (this.userChangedFilters[activeFilter]) {
      delete this.userChangedFilters[activeFilter];
      this.updateFilters().then((res) => {
        this.getTableData();
      });
    }
  }

  resetPage() {
    this.peValues = {};
    this.isRevisedColChange = false;

    this.dataSource.data = this.dataSource.data.map((ele) => {
      const chain_skuValue = parseFloat(ele['Gross Elasticity'].toFixed(2));
      const keyOfPE = `${ele['Chain']}_${ele['SKU']}`;
      this.peValues[keyOfPE] = chain_skuValue;
      return {
        ...ele,
        'Revised PE': chain_skuValue,
      };
    });

    this.isReset = false;
    this.isRevisedColChange = true;
  }

  getCurrentPriceAvg() {
    if (this.dataSource.data.length) {
      let sumOfCurrentPrice = this.dataSource.data
        .map((ele) => ele['Current Price'])
        .reduce((acc, value) => acc + value, 0);
      return (sumOfCurrentPrice / this.dataSource.data.length).toFixed(2);
    }
    return 0;
  }

  getGrossElasticityAverage() {
    if (this.dataSource.data.length) {
      let sumOfCurrentPrice = this.dataSource.data
        .map((ele) => ele['PE'])
        .reduce((acc, value) => acc + value, 0);
      return (sumOfCurrentPrice / this.dataSource.data.length).toFixed(2);
    }
    return 0;
  }

  goBack() {
    this.router.navigate([`/${DASHBOARD}`]);
  }
}
